import Vue from "vue";
import Vuex from "vuex";
import CartModule from "./cart";
import OrdersModule from "./orders";
import AuthModule from "./auth";
import Products from "./products";
import Customers from "./customer";
import Currency from './currency';
import Reports from './reports';
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState({
    key: 'vuex-storage',
    storage: window.localStorage,
    paths: [
      'orders',
      'auth',
      'currency',
      'customers',
      'cart',
      'reports'
    ]
  })],
  modules: {
    cart: CartModule,
    orders: OrdersModule,
    auth: AuthModule,
    products: Products,
    customers: Customers,
    currency: Currency,
    reports: Reports
  },
});
